import React from 'react'
import className from 'classnames/bind'
import { useParams } from 'react-router'

import style from './MyhouseReviewDetailHeader.module.scss'

import IconPrev20x20 from '@Ui/images/myhouse/IconPrev20x20.svg'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { handleNclickMix } from '@Helpers/nclick'
import { NCLICK } from '@Root/contants/lcs'

const cx = className.bind(style)

type Props = {
  title?: string
}

const MyhouseReviewDetailHeader: React.FC<Props> = ({ title }: Props) => {
  const params = useParams<{ complexNo: string }>()
  const complexNo = parseInt(params.complexNo)

  return (
    <header className={cx('header')}>
      <div className={cx('inner')}>
        <a
          href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_COMPLEXES}/${complexNo}/reviews`}
          className={cx('link_back')}
          aria-label="뒤로가기"
          onClick={handleNclickMix(NCLICK.MY_HOUSE.REVIEW_DETAIL.BACK)}
        >
          <IconPrev20x20 />
        </a>
        <h1 className={cx('title')}>{title || '입주민 리뷰'}</h1>
      </div>
    </header>
  )
}

export default MyhouseReviewDetailHeader
